<template>
    <div class="mNavigation">
        <mds-navigation
            v-bind="$attrs"
            v-on="$listeners"
            data-site-name='Mediq'
            data-url-home='/'
            data-breakpoint='1280'
            @click="click"
        >
            <nav slot='content' v-if="$slots.content">
                <slot name="content"></slot>
            </nav>
            <mds-navigation-link title='Home' href='/' text='Home' v-else></mds-navigation-link>
            <nav slot='corporate' v-if="$slots.corporate">
                <slot name="corporate"></slot>
            </nav>
            <nav slot='commerce' v-if="$slots.commerce">
                <slot name="commerce"></slot>
            </nav>
        </mds-navigation>  
    </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { MdsNavigation } from '@mds/navigation'

export default {
    name:  'navigation',
    computed: {},
    created () {},
    methods: {
        click (event) {
            event.preventDefault()
            let itemValue = event.target.getAttribute('item') ? event.target.getAttribute('item') : event.target.getAttribute('data-url-home')
            this.$emit('item-click', this.isValidJSON(itemValue) ? JSON.parse(itemValue) : itemValue)
        },
        isValidJSON(obj) {
            try {
                JSON.parse(obj);
                return true;
            } catch (e) {
                return false
            }
        }
    }

}
</script>

<style lang="scss" scoped>
    .mNavigation {
        /deep/ nav {
            display: inherit;
        }
    }
</style>